var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadphonesRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11C13.009 11 12 12.009 12 13.25V17.25C12 18.491 13.009 19.5 14.25 19.5C15.491 19.5 16.5 18.491 16.5 17.25V13.25C16.5 12.009 15.491 11 14.25 11ZM15 17.25C15 17.664 14.664 18 14.25 18C13.836 18 13.5 17.664 13.5 17.25V13.25C13.5 12.836 13.836 12.5 14.25 12.5C14.664 12.5 15 12.836 15 13.25V17.25ZM5.25 11C4.009 11 3 12.009 3 13.25V17.25C3 18.491 4.009 19.5 5.25 19.5C6.491 19.5 7.5 18.491 7.5 17.25V13.25C7.5 12.009 6.491 11 5.25 11ZM6 17.25C6 17.664 5.664 18 5.25 18C4.836 18 4.5 17.664 4.5 17.25V13.25C4.5 12.836 4.836 12.5 5.25 12.5C5.664 12.5 6 12.836 6 13.25V17.25ZM19.5 9.75V14.75C19.5 15.164 19.164 15.5 18.75 15.5C18.336 15.5 18 15.164 18 14.75V9.75C18 5.201 14.299 1.5 9.75 1.5C5.201 1.5 1.5 5.201 1.5 9.75V14.75C1.5 15.164 1.164 15.5 0.75 15.5C0.336 15.5 0 15.164 0 14.75V9.75C0 4.374 4.374 0 9.75 0C15.126 0 19.5 4.374 19.5 9.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphonesRegular);
export default __webpack_public_path__ + "static/media/headphones-Regular.6a07bbb76a400d484c3aa77500cc6dc1.svg";
export { ForwardRef as ReactComponent };